export default function checkIsTicketGroupNotOnSale({
  ticketGroup,
  isCanceled = false,
  isOnSale = false,
  isScheduled = false,
  hasInvalidReference = false,
}) {
  if (!ticketGroup) {
    return true;
  }

  const isSoldOut = ticketGroup.isSoldOut;
  const isAvailable = ticketGroup.availabilityStatus === 'available';

  return (
    (!isSoldOut && !isCanceled && isAvailable && !isOnSale && !isScheduled) || hasInvalidReference
  );
}
